import * as Err from '@fixtuur/error-context';
import * as E from 'fp-ts/Either';
import * as TE from 'fp-ts/TaskEither';
import { pipe } from 'fp-ts/lib/function';
import * as i from 'io-ts';
import { getConfiguration, getConfigurations } from '../../requests/getConfiguration';
import { RequestError } from '../../requests/requestError';
import * as Particle from './particle/particle';
/**
 * Api.Configuration
 * A concrete configuration set created from a configuration template, with a structure and a single particleId per part in the structure.
 * The order of the particles in the parts array correlates to the order of the parts in the structure's parts array;
 * each particle is positioned at the index of the part it is fullfilling.
 */
const Part = i.intersection([
    i.type({
        cardinality: i.array(i.number),
        name: i.string,
    }),
    i.partial({
        hero: i.boolean,
    }),
]);
const Structure = i.type({ parts: i.array(Part) });
const Particles = i.array(Particle.Id);
const Configuration = i.type({
    parts: Particles,
    template: i.string,
    structure: Structure,
    type: i.string,
});
const Configurations = i.array(Configuration);
export const is = (u) => E.isRight(Configuration.decode(u));
export const isListOf = (u) => E.isRight(Configurations.decode(u));
export const getHeroParts = (configuration) => {
    const heroParts = configuration.structure.parts.filter(p => p.hero === true);
    if (heroParts.length > 0) {
        return heroParts.map(hp => hp.name);
    }
    else {
        throw new Error('No hero part could be found in configuration! Configurations must include at least one hero part. Configuration: ' +
            JSON.stringify(configuration));
    }
};
export const get = (serviceUrls, spaceId, selections) => {
    return pipe(getConfiguration(serviceUrls, spaceId, selections), TE.chain(response => {
        const configuration = response.data?.configurations[0];
        if (!is(configuration)) {
            return TE.left(Err.construct(RequestError.ResponseNotExpectedFormat, {
                responseStatus: response.status.toString(10),
                responseStatusText: response.statusText,
            }));
        }
        return TE.right({
            ...configuration,
        });
    }));
};
const findMaximumPartsCount = (configurations) => {
    const partsCounts = configurations.map(c => c.structure.parts.length);
    return Math.max(...partsCounts);
};
export const getMaxPartsCount = (serviceUrls, spaceId, selections) => {
    return pipe(getConfigurations(serviceUrls, spaceId, selections, 20), TE.chain(response => {
        const configurations = response.data?.configurations;
        if (!isListOf(configurations)) {
            return TE.left(Err.construct(RequestError.ResponseNotExpectedFormat, {
                responseStatus: response.status.toString(10),
                responseStatusText: response.statusText,
            }));
        }
        return TE.right(configurations);
    }), TE.map(findMaximumPartsCount));
};
